var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manual" }, [
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule1"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule2"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule3"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule4"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule5"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule6"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule7"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule8"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule9"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule10"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule11"))),
    ]),
    _c("p", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("goodsPage.rule12"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }